export const CHANGE_CURRENT_PAGE = 'awsCertificates/CHANGE_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'awsCertificates/CHANGE_PAGE_SIZE'
export const CREATE_AWS_CERTIFICATE = 'awsCertificates/CREATE_AWS_CERTIFICATE'
export const FETCH_AWS_CERTIFICATE = 'awsCertificates/FETCH_AWS_CERTIFICATE'
export const FETCH_AWS_CERTIFICATES_LIST = 'awsCertificates/FETCH_AWS_CERTIFICATES_LIST'
export const REMOVE_AWS_CERTIFICATE = 'awsCertificates/REMOVE_AWS_CERTIFICATE'
export const UPDATE_AWS_CERTIFICATE = 'awsCertificates/UPDATE_AWS_CERTIFICATE'
